<script setup>

import { onMounted, ref, reactive } from 'vue'
import LogisticsItem from './components/logisticsItem.vue';
import TitleComponent from '@/components/TitleComponent/index.vue'
import Detail from './detail.vue'
import { useI18n } from 'vue-i18n'
import { forwardPostageRouteAPI } from '@/apis/estimation.js'

const { t } = useI18n();
const param = reactive({
    countryType: [
        {
            "name": "ABC",
            "list": [],
            "isSel": true,
        },
        {
            "name": "DEF",
            "list": [],
            "isSel": false,
        }, {
            "name": "GHI",
            "list": [],
            "isSel": false,
        }, {
            "name": "JKL",
            "list": [],
            "isSel": false,
        }, {
            "name": "MNO",
            "list": [],
            "isSel": false,
        }, {
            "name": "PQR",
            "list": [],
            "isSel": false,
        }, {
            "name": "STU",
            "list": [],
            "isSel": false,
        }, {
            "name": "VWY",
            "list": [],
            "isSel": false,
        }, {
            "name": "Z",
            "list": [],
            "isSel": false,
        },
    ],
    form: {
        destination: '',
        weight: 0,
        productCategory: '',
        length: '',
        width: '',
        height: '',
        features: [],
        lang: ''
    },
    searchtext: 'comprehensive',
    searchsort: ''


})
const classifyAll = ref()
const lang = ref()
const loading = ref(false)

const showType = ref(false);
const showDetail = ref(false);
const list = ref();

const changeDetailShow = () => {
    console.log('222222222')
    showDetail.value = true
    console.log('33333333', showDetail.value)
}
const close = () => {
    showDetail.value = false
}
changeDetailShow
//获取国家信息
const getCountry = async () => {
    const res = await forwardPostageRouteAPI({
        // url:'https://mulebuy.com/wp-admin/admin-ajax.php?action=get_estimation_countries&lang='+lang.value,
        url: 'https://mulebuy.com/wp-json/openapi/v1/logistics/get_estimation_countries?site=mulebuy&lang=' + lang.value,
        method: 'GET'
    })
    if (res.code == 0) {
        console.log('re.data', res.data.response.Data)
        let countryAll = res.data.response.Data
        let arr1 = 'ABC'
        let arr2 = 'DEF'
        let arr3 = 'GHI'
        let arr4 = 'JKL'
        let arr5 = 'MNO'
        let arr6 = 'PQR'
        let arr7 = 'STU'
        let arr8 = 'VWY'
        let arr9 = 'Z'

        countryAll.forEach(el => {
            let word = el.nameEn.charAt(0).toUpperCase()
            if (arr1.includes(word)) {
                param.countryType[0].list.push(el)
            } else if (arr2.includes(word)) {
                param.countryType[1].list.push(el)
            } else if (arr3.includes(word)) {
                param.countryType[2].list.push(el)
            } else if (arr4.includes(word)) {
                param.countryType[3].list.push(el)
            } else if (arr5.includes(word)) {
                param.countryType[4].list.push(el)
            } else if (arr6.includes(word)) {
                param.countryType[5].list.push(el)
            } else if (arr7.includes(word)) {
                param.countryType[6].list.push(el)
            } else if (arr8.includes(word)) {
                param.countryType[7].list.push(el)
            } else if (arr9.includes(word)) {
                param.countryType[8].list.push(el)
            }
        })
        console.log('param.countryType', param.countryType)

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}
const handleChange = () => {
    console.log('form', param.form.productCategory)
}
//获取分类信息
const getClassify = async () => {
    const res = await forwardPostageRouteAPI({
        // url:'https://mulebuy.com/wp-admin/admin-ajax.php?action=get_estimation_category_features&lang='+lang.value,
        url: 'https://mulebuy.com/wp-json/openapi/v1/logistics/get_estimation_category_features?site=mulebuy&lang=' + lang.value,
        method: 'GET'
    })
    if (res.code == 0) {
        console.log('re.data', res.data.response.Data)
        classifyAll.value = res.data.response.Data

    } else {
        ElMessage({ type: 'error', message: res.message })
    }
}


const selctOne = (i) => {
    param.countryType.map((el, index) => {
        if (el.isSel) { el.isSel = false }
        if (index == i) { el.isSel = true }
    })
}
const changeSaerch = (str) => {
    if (str == param.searchtext) {
        if (param.searchsort == 'asc') {
            param.searchsort = 'desc'
        } else if (param.searchsort == '') {
            param.searchsort = 'asc'

        } else {
            param.searchsort = ''
            param.searchtext = 'comprehensive'
        }
    } else {
        param.searchtext = str
        param.searchsort = 'asc'
    }
}
//计算运费
const handleQuery = async () => {
    if (!param.form.destination) {
        ElMessage({ type: 'error', message: $t('setup563') })
        return
    }
    if (loading.value) {
        return
    }


    console.log('param', param.form)
    if (param.form.productCategory) {
        param.form.productCategory.forEach(el => {
            param.form.features.push(el[1])
        })
    }
    loading.value = true
    try {
        const res = await forwardPostageRouteAPI({
            // url:'https://mulebuy.com/wp-admin/admin-ajax.php?action=get_estimation_query_prices&lang='+lang.value+'&wmc-currency=CNY',
            url: 'https://mulebuy.com/wp-json/openapi/v1/logistics/channel_list?lang=' + lang.value + '&wmc-currency=CNY',
            method: 'POST',
            form_data: {
                destination: param.form.destination,
                features: param.form.features,
                lang: lang.value,
                height: Number(param.form.height || 0),
                width: Number(param.form.width || 0),
                length: Number(param.form.length || 0),
                weight: Number(param.form.weight || 0),
            }
        })
        if (res.code == 0) {
            console.log('re.data', res.data.response)
            list.value = res.data.response.Data
            loading.value = false


        } else {
            loading.value = false

            ElMessage({ type: 'error', message: res.message })
        }
    } catch (error) {
        loading.value = false

    }

}
const isMobile = ref(false);
onMounted(() => {
    isMobile.value = /Mobi|Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);

    let language = localStorage.getItem('language');
    if (language == 'zh-cn' || language == 'ZN') {
        lang.value = 'zh'
    } else {
        lang.value = language.toLowerCase()
    }
    getCountry();
    getClassify()
})
</script>
<template>
    <div class="estimation" @click="showType = false">
        <TitleComponent :title="'Freight settlement'" v-if="isMobile == true"></TitleComponent>

        <div class="pcEstimation" v-if="isMobile == false">
            <div class="Estimationimg">
                <div class="title">{{ $t('setup502') }}</div>
                <div class="Remark">{{ $t('setup503') }}</div>
            </div>
            <div class="content">
                <div class="content-title">{{ $t('setup504') }}</div>
                <div class="content-form">
                    <el-form :model="param.form" label-width="0">
                        <el-form-item required>
                            <div class="flex">
                                <div class="flex2">
                                    <div class="tip font">{{ $t('setup546') }} <span>*</span></div>
                                    <el-select v-model="param.form.destination" filterable :placeholder="$t('setup547')"
                                        style="width: 100%">
                                        <el-option-group v-for="group in param.countryType" :key="group.name"
                                            :label="group.name">
                                            <el-option v-for="item in group.list" :key="item.code" :label="item.name"
                                                :value="item.code" />
                                        </el-option-group>
                                    </el-select>
                                    <div class="tip-icon" @click.stop="showType = !showType"></div>
                                    <div class="type-table" v-show="showType" @click.stop="">
                                        <div class="title-group">
                                            <div v-for="(i, index) in param.countryType" :key="index"
                                                :class="i.isSel ? 'sel-title' : ''" @click="selctOne(index)">{{ i.name
                                                }}</div>
                                        </div>
                                        <div>
                                            <div v-for="(i, itype) in param.countryType" class="country-group"
                                                :key="itype">
                                                <div v-if="i.isSel">
                                                    <div v-for="(item, ilist) in i.list" class="countries" :key="ilist"
                                                        @click="param.form.destination = item.code; showType = false">
                                                        {{
                                                            item.name }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="type-table-icon" v-show="showType"></div>
                                </div>
                                <div class="flex2">
                                    <div class="tip font">{{ $t('setup548') }} <span>*</span></div>
                                    <el-input v-model="param.form.weight" type="number">
                                        <!-- <template #prefix>
                                            重量(克)
                                        </template> -->
                                    </el-input>
                                </div>
                            </div>
                        </el-form-item>



                        <el-form-item>
                            <div class="flex">
                                <div class="flex2">
                                    <div class="tip font">{{ $t('setup549') }}</div>

                                    <el-cascader v-model="param.form.productCategory" style="width: 600px;"
                                        :placeholder="$t('setup550')" :options="classifyAll" @change="handleChange"
                                        :props="{
                                            children: 'children',
                                            value: 'id',
                                            label: 'name',
                                            checkStrictly: false,
                                            multiple: true
                                        }" clearable collapse-tags />
                                </div>
                                <div class="flex flex2">
                                    <div class="flex3"> <el-input v-model="param.form.length" type="number"
                                            placeholder="cm">
                                            <template #prefix>

                                                <div class="font">{{ $t('setup551') }}</div>

                                            </template>
                                        </el-input></div>
                                    <div class="flex3"><el-input v-model="param.form.width" type="number"
                                            placeholder="cm">
                                            <template #prefix>

                                                <div class="font">{{ $t('setup552') }}</div>

                                            </template>
                                        </el-input></div>
                                    <div class="flex3"> <el-input v-model="param.form.height" type="number"
                                            placeholder="cm">
                                            <template #prefix>

                                                <div class="font">{{ $t('setup553') }}</div>
                                            </template>
                                        </el-input></div>


                                </div>
                            </div>
                            <!-- <el-input
                          
                            placeholder="Type something"
                            >
                            <template #prefix>
                                产品类别
                            </template>
                        </el-input> -->


                        </el-form-item>



                        <el-form-item>
                            <el-button class="btn" @click="handleQuery"
                                :loading="loading">{{ $t('setup554') }}</el-button>
                            <!-- <el-button type="primary" @click="handleQuery">QUERY</el-button> -->
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content-list">
                    <div class="list-tag">
                        <div :class="param.searchtext == 'comprehensive' ? 'active' : ''"
                            @click="changeSaerch('comprehensive')">
                            {{ $t('setup555') }}</div>
                        <!-- <div :class="param.searchtext == 'price' ? 'active' : ''" @click="changeSaerch('price')">
                            <div>price</div>
1
                            <div :class="param.searchsort == 'asc' ? 'sort-asc' : 'sort-desc'"
                                v-if="param.searchsort !== '' && param.searchtext == 'price'">
                                <img src="../../assets/images/checktriangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                            <div class="sort" v-else>
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                        </div>
                        <div :class="param.searchtext == 'Delivered' ? 'active' : ''" @click="changeSaerch('Delivered')">
                            <div>Delivered</div>
                            <div :class="param.searchsort == 'asc' ? 'sort-asc' : 'sort-desc'"
                                v-if="param.searchsort !== '' && param.searchtext == 'Delivered'">
                                <img src="../../assets/images/checktriangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                            <div class="sort" v-else>
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                        </div> -->
                    </div>
                    <!-- <div class="tip-line">
                        Reminder: Please select your destination country, and the system will search for available
                        routes at that
                        location
                    </div> -->
                    <div class="list">
                        <LogisticsItem v-for="i in list" :item="i" />
                    </div>
                </div>
            </div>
        </div>
        <div class="phoneEstimation" v-else>
            <div class="content">
                <div class="content-form">
                    <el-form :model="param.form" label-width="0">
                        <el-form-item required>
                            <div class="flex1">
                                <div class="tip font">{{ $t('setup546') }} <span>*</span></div>
                                <el-select v-model="param.form.destination" filterable :placeholder="$t('setup547')"
                                    style="width: 100%">
                                    <el-option-group v-for="group in param.countryType" :key="group.name"
                                        :label="group.name">
                                        <el-option v-for="item in group.list" :key="item.code" :label="item.name"
                                            :value="item.code" />
                                    </el-option-group>
                                </el-select>
                                <div class="tip-icon" @click.stop="showType = !showType"></div>
                                <div class="type-table" v-show="showType" @click.stop="">
                                    <div class="title-group">
                                        <div v-for="(i, index) in param.countryType" :class="i.isSel ? 'sel-title' : ''"
                                            @click="selctOne(index)">{{ i.name
                                            }}</div>
                                    </div>
                                    <div>
                                        <div v-for="i in param.countryType" class="country-group">
                                            <div v-if="i.isSel">
                                                <div v-for="item in i.list" class="countries"
                                                    @click="param.form.destination = item.code; showType = false">
                                                    {{
                                                        item.name }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="type-table-icon" v-show="showType"></div>
                            </div>
                        </el-form-item>
                        <el-form-item>
                            <div class="flex1">
                                <div class="tip font">{{ $t('setup548') }} <span>*</span></div>
                                <el-input v-model="param.form.weight" type="number">
                                </el-input>
                            </div>
                        </el-form-item>


                        <!--  <el-form-item>
                            
                                <div class="flex1">
                                    <div class="tip font">Product category</div>

                                    <el-cascader v-model="param.form.productCategory" style="width: 600px;"
                                        placeholder="Please select category" :options="classifyAll"
                                        @change="handleChange" :props="{
                                            children: 'children',
                                            value: 'id',
                                            label: 'name',
                                            checkStrictly: false,
                                            multiple: true
                                        }" clearable collapse-tags />
                                </div>
                           
                        </el-form-item> -->
                        <el-form-item>

                            <div class="flex flex1">
                                <div class="flex3"> <el-input v-model="param.form.length" type="number"
                                        placeholder="cm">
                                        <template #prefix>

                                            <div class="font">{{ $t('setup551') }} </div>

                                        </template>
                                    </el-input></div>
                                <div class="flex3"><el-input v-model="param.form.width" type="number" placeholder="cm">
                                        <template #prefix>

                                            <div class="font">{{ $t('setup552') }} </div>

                                        </template>
                                    </el-input></div>
                                <div class="flex3"> <el-input v-model="param.form.height" type="number"
                                        placeholder="cm">
                                        <template #prefix>

                                            <div class="font">{{ $t('setup553') }} </div>
                                        </template>
                                    </el-input></div>


                            </div>
                        </el-form-item>



                        <el-form-item>
                            <el-button class="btn" @click="handleQuery" :loading="loading">{{ $t('setup554') }}
                            </el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div class="content-list">
                    <div class="list-tag">
                        <div :class="param.searchtext == 'comprehensive' ? 'active' : ''"
                            @click="changeSaerch('comprehensive')">
                            {{ $t('setup555') }} </div>
                        <!-- <div :class="param.searchtext == 'price' ? 'active' : ''" @click="changeSaerch('price')">
                            <div>price</div>

                            <div :class="param.searchsort == 'asc' ? 'sort-asc' : 'sort-desc'"
                                v-if="param.searchsort !== '' && param.searchtext == 'price'">
                                <img src="../../assets/images/checktriangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                            <div class="sort" v-else>
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                        </div>
                        <div :class="param.searchtext == 'Delivered' ? 'active' : ''" @click="changeSaerch('Delivered')">
                            <div>Delivered</div>
                            <div :class="param.searchsort == 'asc' ? 'sort-asc' : 'sort-desc'"
                                v-if="param.searchsort !== '' && param.searchtext == 'Delivered'">
                                <img src="../../assets/images/checktriangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                            <div class="sort" v-else>
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                                <img src="../../assets/images/triangle.png" alt="" srcset="">
                            </div>
                        </div> -->
                    </div>
                    <!-- <div class="tip-line">
                        Reminder: Please select your destination country, and the system will search for available
                        routes at that
                        location
                    </div> -->
                    <div class="list">
                        <LogisticsItem v-for="i in list" :item="i" @show="changeDetailShow" />
                    </div>
                </div>
            </div>
        </div>
        <div>
            <el-drawer v-model="showDetail" :title="'Package restrictions'" show-close :with-header="true"
                direction="btt" :before-close="close" size="80%">
                <Detail />
                <!-- <div>111111111</div> -->
            </el-drawer>
        </div>
    </div>
</template>
<style scoped lang="scss">
:deep(.el-input__inner) {
    text-align: end;
}

:deep(.el-select__placeholder) {
    text-align: end;
}

:deep(.el-cascader__tags) {
    left: 130px;
}

:deep(.el-select__wrapper) {
    padding-left: 150px;
    text-align: right;
}

.estimation {
    background-color: #eef0f1;

    .pcEstimation,
    .phoneEstimation {
        width: 1200px;
        margin: auto;
        padding: 22px 0 44px 0;

        .Estimationimg {

            width: 100%;
            height: 200px;
            background-image: url('@/assets/images/estimation.png');
            /* 背景图片覆盖整个容器，不留空白 */
            background-size: 100% auto;
            /* 背景图片不平铺 */
            background-repeat: no-repeat;
            padding-left: 50px;

            .title {
                padding-top: 67px;
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 24px;
                color: #FFFFFF;
                line-height: 31px;
                text-align: left;
                font-style: normal;
            }

            .Remark {
                padding-top: 15px;
                font-family: MicrosoftYaHei;
                font-size: 12px;
                color: #FFFFFF;
                line-height: 16px;
                text-align: left;
                font-style: normal;
            }
        }

        .content {
            background: #FFFFFF;
            border-radius: 8px;
            margin-top: 20px;
            padding: 30px 20px 0 20px;

            .content-title {
                font-family: MicrosoftYaHei, MicrosoftYaHei;
                font-weight: bold;
                font-size: 18px;
                color: #11192D;
                line-height: 24px;
                text-align: left;
                font-style: normal;
                padding-bottom: 30px;
            }

            .content-form {
                padding: 0 10px;

                .flex {
                    width: 100%;
                    display: flex;
                    justify-content: space-between;
                }

                .flex2,
                .flex1 {
                    width: calc(50% - 10px);
                    display: flex;
                    justify-content: space-between;
                    position: relative;

                    .tip {
                        height: 32px;
                        line-height: 32px;
                        position: absolute;
                        top: 0;
                        left: 15px;
                        z-index: 10;

                        >span {
                            color: #f00;
                        }
                    }

                    .tip-icon {
                        // background-color: #f00;
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 10;
                        width: 32px;
                        height: 32px;
                    }

                    .type-table {
                        width: 60vw;
                        // height: 500px;
                        position: absolute;
                        top: 42px;
                        left: 0;
                        background-color: #f8f8f8;
                        z-index: 11;
                        border-radius: 20px;
                        transition: all 0.5s;
                        padding: 10px 0 20px;

                        .title-group {
                            height: 32px;
                            display: flex;
                            justify-content: space-around;
                            border-bottom: 1px solid #fff;

                            >div {
                                border-bottom: 2px solid transparent;

                                &:hover {
                                    color: #ec4634;
                                }
                            }

                            .sel-title {
                                border-bottom: 2px solid #ec4634;
                                color: #ec4634;
                            }
                        }

                        .country-group {
                            >div {
                                display: flex;
                                flex-wrap: wrap;
                                padding: 15px;

                                .countries {
                                    width: 20%;
                                    padding: 0 5px;

                                    &:hover {
                                        color: #ec4634;
                                    }

                                    // border: 1px solid;
                                }
                            }



                        }
                    }

                    .type-table-icon {
                        width: 10px;
                        height: 10px;
                        background-color: #f8f8f8;
                        position: absolute;
                        bottom: -16px;
                        left: 100px;
                        z-index: 12;
                        transform: rotate(45deg);

                    }
                }

                .flex3 {
                    width: calc(33% - 10px);
                }

                .flex1 {
                    width: 100%;
                }

                .btn {

                    height: 46px;
                    line-height: 46px;
                    margin: 0 auto;
                    padding: 0 40px;
                    background: #FC3938;
                    border-radius: 28px;
                    font-family: MicrosoftYaHei, MicrosoftYaHei;
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                    text-align: center;
                    font-style: normal;
                    text-transform: uppercase;
                }
            }

            .content-list {
                .list-tag {
                    display: flex;
                    align-items: center;
                    margin: 50px 0 20px;
                    cursor: pointer;

                    >div {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        margin-right: 50px;
                        font-family: MicrosoftYaHei;
                        font-size: 16px;
                        color: #333333;
                        font-style: normal;
                    }

                    .active {
                        color: #FC3938;
                    }

                    .sort,
                    .sort-asc,
                    .sort-desc {
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        justify-content: center;
                        margin-left: 6px;

                        >img {
                            width: 7px;
                            height: 5px;
                        }

                        >img:first-child {
                            margin-bottom: 2px;
                        }
                    }

                    .sort {
                        >img:first-child {
                            transform: rotate(180deg);
                        }
                    }

                    .sort-desc {
                        transform: rotate(180deg);
                    }
                }

                .tip-line {
                    width: 100%;
                    background: #FFF1EB;
                    border-radius: 4px;
                    padding: 8px 10px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #811414;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                    margin-bottom: 5px;
                }

                .list {
                    padding-bottom: 40px;

                }
            }
        }
    }

    .font {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        color: #333333;
        font-style: normal;
    }

    .phoneEstimation {
        width: 100%;
        min-height: 100vh;

        .content {
            background: transparent;
            padding: 15px;



            .content-form {
                padding: 0;

                .flex2,
                .flex1 {

                    .tip {
                        height: 40px;
                        line-height: 40px;
                    }

                    .tip-icon {
                        position: absolute;
                        top: 0;
                        right: 0;
                        z-index: 10;
                        width: 32px;
                        height: 32px;
                    }

                    .type-table {
                        width: 100%;
                        background-color: #fff;
                        z-index: 11;
                        border-radius: 10px;
                        padding: 5px 0 10px;

                        .title-group {}

                        .country-group {
                            >div {
                                .countries {
                                    width: 25%;
                                }
                            }



                        }
                    }

                    .type-table-icon {
                        background-color: #fff;

                    }
                }

                .flex3 {
                    width: calc(33% - 10px);
                }

                .flex1 {
                    width: 100%;
                }

                .btn {
                    width: 100%;
                    height: 45px;
                    background: #FC3938;
                    border-radius: 8px;
                    line-height: 45px;
                }
            }

            .content-list {
                .list-tag {
                    margin: 30px 0 15px;

                    >div {
                        margin-right: 30px;
                    }

                    .active {
                        color: #FC3938;
                    }

                    .sort,
                    .sort-asc,
                    .sort-desc {

                        >img {
                            width: 7px;
                            height: 5px;
                        }

                        >img:first-child {
                            margin-bottom: 2px;
                        }
                    }

                    .sort {
                        >img:first-child {
                            transform: rotate(180deg);
                        }
                    }

                    .sort-desc {
                        transform: rotate(180deg);
                    }
                }

                .tip-line {
                    width: 100%;
                    background: #FFF1EB;
                    border-radius: 4px;
                    padding: 8px 10px;
                    font-family: MicrosoftYaHei;
                    font-size: 14px;
                    color: #811414;
                    line-height: 19px;
                    text-align: left;
                    font-style: normal;
                    margin-bottom: 5px;
                }

                .list {
                    padding-bottom: 40px;

                }
            }
        }

        :deep(.el-select__wrapper) {
            height: 40px;
        }

        :deep(.el-input__wrapper) {
            height: 40px;
        }
    }
}
</style>